import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Floating%20abstract%20shopping%20data%20dashboard%20with%20warm%20amber%20and%20soft%20apricot%20gradient%20background%2C%20modern%20SaaS%20interface%20with%20elegant%20product%20grids%20and%20analytics%20widgets%2C%20glowing%20soft%20geometric%20elements%2C%20clean%20contemporary%20design%2C%20ethereal%20morning%20light%20atmosphere%2C%20premium%20technology%20aesthetic&width=1800&height=900&seq=hero-bg-sugargoo-v2&orientation=landscape&nocache=true"
          alt="Sugargoo Spreadsheet shopping intelligence dashboard background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-800">Updated Product Database</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          Sugargoo Spreadsheet
          <br />
          <span className="text-primary-300">The Ultimate Shopping Database</span>
        </h1>

        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover updated Sugargoo spreadsheets, trending product finds, expert shipping guides, warehouse information, verified reviews, and money-saving discount resources — all organized in one intelligent platform for smarter international shopping decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer shadow-lg shadow-primary-500/20 hover:shadow-primary-500/30"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-base font-semibold hover:bg-background-50 transition-all duration-200 cursor-pointer border border-background-200/30"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-12">
          {[
            { icon: 'ri-database-2-line', text: 'Updated Product Database' },
            { icon: 'ri-guide-line', text: 'Real Shopping Guides' },
            { icon: 'ri-ship-line', text: 'Shipping Cost Analysis' },
            { icon: 'ri-user-smile-line', text: 'Beginner Friendly' },
            { icon: 'ri-shield-check-line', text: 'Safety Information' },
          ].map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-2 text-xs md:text-sm text-background-200"
            >
              <i className={`${item.icon} text-primary-300 text-sm`}></i>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}